import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { confirmBooking } from "../../../../redux/reducers/HotelPortalReducer";
import { Button, Tooltip, TextField, Grid } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import cloneDeep from "lodash/cloneDeep";

interface IConfirmationProps {
  UItype: "text" | "button";
  rowParams: any;
  stateChanger?: (hideButton: string) => void;
}

export default function Confirmation(props: IConfirmationProps): JSX.Element {
  const dispatch = useDispatch();
  const { UItype, rowParams, stateChanger } = props;
  const [confirmationCode, setConfirmationCode] = useState<string>(rowParams.confirmationCode);
  const [showingTextField, setShowingTextField] = useState<boolean>(false);
  const hotelBookings: any = useSelector((state: IRootState) => state.hotelBookings.hotelBookings);
  const fetchingThunk = useSelector((state: IRootState) => state.hotelBookings.fetchingThunk);

  //Handlers
  const handleConfirmation = (code: string, temp_id: string, hotelId: string): void => {
    if (code) {
      const bookingDetail = hotelBookings.find((booking: any) => {
        return booking.temp_id === temp_id;
      });
      if (bookingDetail) {
        const newBooking = cloneDeep(bookingDetail);
        newBooking.confirmationCode = code;
        delete newBooking.changes;
        delete newBooking._id;
        delete newBooking.id;
        dispatch(
          confirmBooking({
            booking: newBooking,
            hotelID: hotelId,
          })
        );
      }
    }
  };
  const handleCodeChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setConfirmationCode(event.target.value);
  };
  const toggleConfirmOverlay = (action: string): void => {
    setShowingTextField(!showingTextField);
    if (stateChanger) {
      if (action === "show") {
        stateChanger("cancelation");
      } else {
        stateChanger("");
      }
    }
  };
  return (
    <>
      {!showingTextField && (
        <>
          {UItype === "button" && (
            <Tooltip title="Confirm this booking with a confirmation code">
              <>
                <Button
                  disabled={rowParams.statusName !== "additions" || fetchingThunk}
                  color="success"
                  sx={{ color: "white" }}
                  onClick={() => toggleConfirmOverlay("show")}
                >
                  <DoneIcon sx={{ fontSize: "14px" }} />
                </Button>
              </>
            </Tooltip>
          )}
          {UItype === "text" && (
            <Grid container>
              <Grid
                item
                sx={{ width: "calc(100% - 30px)", whiteSpace: "nowrap", textOverflow: "ellipsis", overflowX: "hidden" }}
              >
                {confirmationCode}
              </Grid>
              {confirmationCode !== "" && (
                <Grid item sx={{ cursor: "pointer" }} onClick={() => toggleConfirmOverlay("show")}>
                  <Tooltip title="Edit Confirmation Code">
                    <EditIcon sx={{ ml: 2, fontSize: "14px" }} />
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          )}
        </>
      )}
      {showingTextField && (
        <TextField
          required
          fullWidth
          placeholder="Confirmation Code"
          onChange={(e) => handleCodeChange(e)}
          inputRef={(input) => input && input.focus()}
          value={confirmationCode}
          InputProps={{
            endAdornment: (
              <>
                <DoneIcon
                  sx={{ ml: 1, cursor: "pointer", fontSize: "14px" }}
                  onClick={() => {
                    if (confirmationCode !== "") {
                      handleConfirmation(confirmationCode, rowParams.temp_id, rowParams.hotel_id);
                      toggleConfirmOverlay("show");
                    }
                  }}
                />
                <ClearIcon
                  sx={{ ml: 1, cursor: "pointer", fontSize: "14px" }}
                  onClick={() => {
                    toggleConfirmOverlay("hide");
                  }}
                />
              </>
            ),
          }}
        />
      )}
    </>
  );
}
